// extracted by mini-css-extract-plugin
module.exports = {"burger":"MobileMenu_burger__ZVmR2","open":"MobileMenu_open__pY_gq"};